import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import ProtectedRoute from "../../core/components/ProtectedRoute";
import Error404 from "../auth/error/error-404/error400";
import { useAuth } from "../../core/hooks/useAuth";
import { all_routes } from "./all_routes";
import { role } from "../../core/constants/userConstants"; // Import role constants
import { checkForcePassChage } from "../../core/api/moodleUserApi";
const ALLRoutes: React.FC = () => {
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const { moodleUser, isMoodleUserLoading } = useAuth();
  const isForcePassChange = sessionStorage.getItem("isForcePassChange") === "true";
  const JWT = sessionStorage.getItem("wstoken");
  const location = useLocation();

  if (isForcePassChange) {
    if (location.pathname !== all_routes.login) {
      return <Navigate to={all_routes.login} replace />;
    }
  } else if (JWT) {
    if (
      !moodleUser?.role ||
      (Array.isArray(moodleUser?.role) && moodleUser?.role.length === 0) ||
      moodleUser?.role.roleid === role.student
    ) {
      if (location.pathname === all_routes.login || location.pathname === '/') {
        return <Navigate to={all_routes.studentDashboard} replace />;
      }
    } else {
      if (location.pathname !== all_routes.login) {
        return <Navigate to={all_routes.login} replace />;
      }
    }
  } else {
    if (location.pathname === all_routes.login) {
      // Cho phép truy cập đăng nhập
    } else {
      return <Navigate to={all_routes.login} replace />;
    }
  }

  return (
    <>
      <Routes>
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<ProtectedRoute>{route.element}</ProtectedRoute>}
              key={idx}
            />
          ))}
        </Route>

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route path="*" element={<Error404 />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={dataTheme === "light" ? "dark" : "light"}
      />
    </>
  );
};

export default ALLRoutes;
